<script lang="ts">
import { defineComponent, ref } from 'vue';
import NavigationInnerHead from 'components/User/NavigationInnerHead.vue';
// import { useQuasar } from 'quasar';

export default defineComponent({
  name: 'Support',

  components: { NavigationInnerHead },

  setup() {
    // const $q = useQuasar();
    const supportRequestForm = ref({
      title: '',
      type: '',
      message: '',
      user: '',
      type: '',
      request: '',
    });
    const requestFormLoading = ref(false);
    const requestFormDialog = ref({
      model: false,
    });

    const typeOptions = [
      { label: 'Sipariş', value: 'O' },
      { label: 'Ürün', value: 'P' },
    ];

    return {
      supportRequestForm,
      requestFormLoading,
      requestFormDialog,
      typeOptions,
      // sendSupportRequest: () => {},
    };
  },
});
</script>

<template>
  <q-card class="bg-transparent shadow-0">
    <div class="flex justify-between items-center q-mb-md">
      <div>
        <navigation-inner-head title="Destek Taleplerim" icon="support_agent" />
      </div>
      <div>
        <q-btn no-caps rounded color="primary" @click="requestFormDialog.model = true">
          <q-icon name="add_circle" size="1.2rem" left />
          Destek Talebi Oluştur
        </q-btn>
      </div>
    </div>
    <q-separator color="accent" />
    <div class="row">
      <div class="col-12 row q-py-lg"></div>
    </div>
  </q-card>

  <q-dialog v-model="requestFormDialog.model">
    <q-card style="min-width: 500px">
      <q-card-section class="flex justify-between items-center bg-accent">
        <div class="text-body1 text-weight-bold flex items-center">
          <q-icon name="help" size="1.7rem" left />
          Yeni Destek Talebi
        </div>
        <div>
          <q-btn flat round icon="close" @click="requestFormDialog.model = false" />
        </div>
      </q-card-section>
      <q-card-section class="text-weight-medium text-grey-8 q-pb-none">
        <div>Destek talebi için lütfen aşağıdaki alanları doldurunuz.</div>
      </q-card-section>
      <q-card-section>
        <q-form>
          <div class="row q-col-gutter-lg">
            <div class="col-12 col-lg-6">
              <div class="user-support--input">
                <q-input v-model="supportRequestForm.title" outlined label="Başlık">
                  <template v-slot:prepend>
                    <q-icon name="arrow_forward" />
                  </template>
                </q-input>
              </div>
              <div class="user-support--input">
                <q-input v-model="supportRequestForm.message" outlined label="Mesajınız" type="textarea" rows="5">
                  <template v-slot:prepend>
                    <q-icon name="arrow_forward" />
                  </template>
                </q-input>
              </div>
              <div class="user-support--input">
                <q-select v-model="supportRequestForm.type" outlined label="Talep Seçin" :options="typeOptions" option-label="label" option-value="value">
                  <template v-slot:prepend>
                    <q-icon name="arrow_forward" />
                  </template>
                </q-select>
              </div>
            </div>
            <div class="col-12 col-lg-6 column">
              <div class="user-support--input column items-stretch self-end">
                <q-btn
                  color="primary"
                  label="Gönder"
                  @click="sendSupportRequest"
                  :loading="requestFormLoading"
                  :disable="!supportRequestForm.title || !supportRequestForm.message || !supportRequestForm.type"
                />
              </div>
            </div>
          </div>
        </q-form>
      </q-card-section>
    </q-card>
  </q-dialog>
</template>

<style scoped>
.user-support--input {
  margin-bottom: 1rem;
}
</style>
